import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";
import logo from "../../assets/logo/logo.jpg";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
  
      if (currentScrollY === 0) {
        setIsVisible(true); // Always show navbar at the very top
      } else if (currentScrollY > lastScrollY) {
        setIsVisible(false); // Scrolling down
      } else {
        setIsVisible(true); // Scrolling up
      }
  
      setLastScrollY(currentScrollY);
    };
  
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);
  

  return (
    <header className={`header ${isVisible ? "visible" : "hidden"}`}>
      <NavLink to="/" className="logo" onClick={() => setMenuOpen(false)}>
        <img src={logo} alt="Logo" />
      </NavLink>

      {/* Desktop Navigation */}
      <nav className="navbar">
        <NavLink to="/" end>Home</NavLink>
        <NavLink to="/about">About</NavLink>
        <NavLink to="/music">Music</NavLink>
        <NavLink to="/curriculum">Curriculum</NavLink>
        <NavLink to="/contact">Contact</NavLink>
      </nav>

 
      <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        ☰
      </div>

      {/* Mobile Sidebar */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={() => setMenuOpen(false)}>✖</button>
        <NavLink to="/" end onClick={() => setMenuOpen(false)}>Home</NavLink>
        <NavLink to="/about" onClick={() => setMenuOpen(false)}>About</NavLink>
        <NavLink to="/music" onClick={() => setMenuOpen(false)}>Music</NavLink>
        <NavLink to="/curriculum" onClick={() => setMenuOpen(false)}>Curriculum</NavLink>
        <NavLink to="/contact" onClick={() => setMenuOpen(false)}>Contact</NavLink>
      </div>
    </header>
  );
};

export default Navbar;
